export var FORM_STEPS_KEYS;
(function (FORM_STEPS_KEYS) {
    FORM_STEPS_KEYS["TYPE_SELECT_FIELDS"] = "TYPE_SELECT_FIELDS";
    FORM_STEPS_KEYS["MAIN_FIELDS"] = "MAIN_FIELDS";
    FORM_STEPS_KEYS["SUBJECT_FIELDS"] = "SUBJECT_FIELDS";
    FORM_STEPS_KEYS["PASSWORD_RECOVER_FIELDS"] = "PASSWORD_RECOVER_FIELDS";
})(FORM_STEPS_KEYS || (FORM_STEPS_KEYS = {}));
;
export var FORM_TYPES_KEYS;
(function (FORM_TYPES_KEYS) {
    FORM_TYPES_KEYS["EMAIL"] = "email";
    FORM_TYPES_KEYS["GOOGLE"] = "google";
    FORM_TYPES_KEYS["UNI_ACCOUNT"] = "uni-account";
})(FORM_TYPES_KEYS || (FORM_TYPES_KEYS = {}));
;
